import * as signalR from "@microsoft/signalr";
import { HubConnection } from "@microsoft/signalr";
import * as Msal from 'msal';
import { signalRConnected, signalRUpdate } from "../actions/utility-actions";
import { AppSettings } from "../utils/app-settings";

let connection : HubConnection;

/**
 * Start the SignalR connection 
 * @param {string} url The hub to hit
 */
const createConnection = (url:string) => {
    // Connect to RestaurantHub
    const msal = window.msal as Msal.UserAgentApplication;
    const request = {
        scopes: [AppSettings._adScope]
    } as Msal.AuthenticationParameters;

    return msal.acquireTokenSilent(request)
        .then((response : Msal.AuthResponse) => { 
            connection = new signalR.HubConnectionBuilder()
                                .withUrl(url, { accessTokenFactory: () => response.accessToken })
                                .withAutomaticReconnect()
                                .build();

            return connection.start();

        })
        .catch((error : any) => {
            console.error('FAILURE ESTABLISHING SIGNALR CONNECTION');
        });    
};

export const signalRMiddleware = (store: any) => (next: any) => (action: any) => {

    switch (action.type) {
        case "SET_USER_INFO" : {

            const url = `${ AppSettings._apiHost }/hubs/notifications`;

            const connProm = createConnection(url);

            // Subscribe to the server
            connProm
                .then((data:any) => {

                    store.dispatch(signalRConnected());
                    
                    // Wire up listener to notifications
                    connection
                        .on('onNotification', (data:any) => {
                            store.dispatch(signalRUpdate(data));
                    });

                })
                .catch((err:any) => {
                    console.error(err);
                });
            break;
        }
        case "SEND_WEBSOCKET_MESSAGE": {
            // socket.send(action.payload);
            return;
        }
    }

    return next(action);
};
